export default __webpack_public_path__ + "static/media/item6.78b694b9.jpeg";